/**
 * Image URL utilities.
 * R2 serves images as-is (no on-the-fly transforms like Cloudinary).
 * These functions pass through URLs unchanged, maintaining the same API
 * for components that call them.
 */

export function optimizeCloudinaryUrl(
  url: string | null | undefined,
  _options: {
    width?: number;
    height?: number;
    quality?: "auto" | "auto:low" | "auto:eco" | "auto:good" | "auto:best" | number;
    format?: "auto" | "webp" | "avif" | "jpg" | "png";
  } = {}
): string {
  if (!url) return "";
  return url;
}

export function optimizeHeroImage(url: string | null | undefined): string {
  return url || "";
}

export function optimizeLogoImage(url: string | null | undefined, _size: number = 120): string {
  return url || "";
}

export function optimizeThumbnail(url: string | null | undefined, _size: number = 64): string {
  return url || "";
}
